<template>
  <form class="form">
    <h2 class="modal__heading headingThree">Login</h2>
    <p class="paragraph">Please login to save products to your project book.</p>
    <p v-show="hasError">{{ errorMessage }}</p>
    <div class="form__row">
      <input v-model="email" type="email" name="new project" placeholder="Email address" required="required">
    </div>
    <div class="form__row">
      <input v-model="password" type="password" name="new project" placeholder="Password" required="required">
    </div>
    <button type="submit" class="button modal__button" @click.prevent="doLogin">Login</button>

    <p class="paragraph">
      If you don't yet have a login, please <a href="/customer/register"><strong>register
        now</strong></a>.
    </p>
    <p class="paragraph">
      Forgotten your password? <a href="/customer/password/forgot"><strong>Reset it
        here</strong></a>.
    </p>
  </form>
</template>
<script>
import { eventBus } from "../app";
import axios from '../config/axios';

export default {
	data() {
		return {
			email: "",
			password: "",
			hasError: false,
			errorMessage: "",
		};
	},
	methods: {
		reset() {
			this.email = "";
			this.password = "";
			this.hasError = false;
			this.errorMessage = "";
		},
		async doLogin() {
			const self = this;

			const formData = {
				loginName: this.email,
				password: this.password,
			};

			axios.post(
				"/actions/users/login", formData
			).then((response) => {
				if ('returnUrl' in response.data && response.data.returnUrl) {
					axios.defaults.headers['X-CSRF-Token'] = response.data.csrfTokenValue;
					window.csrfToken = response.data.csrfTokenValue;
					eventBus.$emit("login-success");
					self.reset();
				} else {
					// lets assume error
					self.hasError = true;
					self.errorMessage = response.data.errorCode;
				}
			}).catch((error) => {
				self.hasError = true;
				self.errorMessage = error.response.data.message;
			}

			);
			
		},
	},
};
</script>
